import React, { useState } from "react";
import { Link } from "react-router-dom";

import LayersIcon from "../../icons/layersIcon.component";
import useAppContext from "../../../hooks/useAppContext";

import { StyledWrapper } from "./navigationMenu.style";

const NavigationMenu = () => {
  const {
    railsContext: { adminNavigationMenu },
  } = useAppContext();

  const [activeMenuItem, setActiveMenuItem] = useState(
    adminNavigationMenu.active_menu_item,
  );
  const [activeSubMenuItem, setActiveSubMenuItem] = useState(
    adminNavigationMenu.active_sub_menu_item,
  );
  const [openMenuItems, setOpenMenuItems] = useState([]);

  const buildMenu = (
    <div className="menu">
      {adminNavigationMenu.nav_menu.map((item, index) => {
        if (item?.skip_nav) return null;
        return (
          <div className="menu-item-wrapper" key={index}>
            <div
              className={`menu-item ${activeMenuItem == index ? "active" : ""}`}
            >
              {item.link_to_page && activeMenuItem != index ? (
                <Link
                  to={item.path}
                  onClick={() => {
                    menuItemClick(index, null);
                  }}
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  onClick={() => {
                    activeMenuItem != index ? toggleSubmenu(index) : "";
                  }}
                >
                  {item.label}
                </a>
              )}
              {activeMenuItem == index && <LayersIcon />}
            </div>
            {item.children && (
              <div
                className={`submenu ${activeMenuItem == index || openMenuItems.includes(index) ? "" : "closed"}`}
              >
                {item.children.map((subItem, subIndex) => {
                  if (subItem?.skip_nav) return null;
                  const path = `${item.path}/${subItem.path}`;
                  return (
                    <div
                      className={`submenu-item ${activeMenuItem == index && activeSubMenuItem == subIndex ? "active" : ""}`}
                      key={subIndex}
                    >
                      <div className="item-marker"></div>
                      {activeMenuItem != index ||
                      activeSubMenuItem != subIndex ? (
                        subItem.external_path == true ? (
                          <a href={subItem.path}>{subItem.label}</a>
                        ) : (
                          <Link
                            to={path}
                            onClick={() => {
                              menuItemClick(index, subIndex);
                            }}
                          >
                            {subItem.label}
                          </Link>
                        )
                      ) : (
                        <a>{subItem.label}</a>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  const menuItemClick = (index, subIndex) => {
    setActiveMenuItem(index);
    setActiveSubMenuItem(subIndex);
    setOpenMenuItems(subIndex != null ? [index] : []);
    window.scrollTo(0, 0);
  };

  const toggleSubmenu = (item) => {
    let items = [...openMenuItems];
    if (items.includes(item)) {
      let index = items.indexOf(item);
      items.splice(index, 1);
    } else {
      items.push(item);
    }
    setOpenMenuItems(items);
  };

  return <StyledWrapper>{buildMenu}</StyledWrapper>;
};

export default NavigationMenu;
